"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RowComponents = require("./RowComponents");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var checkAreEqual = _RowComponents.areEqual;

var GenericSubRow = function GenericSubRow(props) {
  if (props.structure.customMemoAreEqual) {
    checkAreEqual = props.structure.customMemoAreEqual;
  }

  var myMap = (0, _RowComponents.mapMaker)(props.structure.headers, props.structure.dataKeys);

  var fillSubRow = function fillSubRow(rowContent) {
    var filler = [];
    myMap.forEach(function (value, key) {
      var classes = 'cell';

      if (props.structure.rowFormat[value] && props.structure.rowFormat[value].hasPriority) {
        classes = classes + ' priority';
      }

      if (props.structure.rowFormat[value] && props.structure.rowFormat[value].format) {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: value,
          className: classes
        }, value && rowContent[value] ? props.structure.rowFormat[value].format(rowContent, value) : '-'));
      } else if (props.structure.rowFormat[value] && props.structure.rowFormat[value].clickable) {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: key,
          className: classes
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "modalLink",
          data: rowContent[value],
          onClick: function onClick() {
            return props.structure.rowFormat[value].clickable(rowContent);
          }
        }, props.structure.rowFormat[value].name(rowContent[value]) || '-')));
      } else {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: key,
          className: classes
        }, value && rowContent[value] ? rowContent[value] : '-'));
      }
    });
    return filler;
  };

  var clickHandler = function clickHandler(e) {
    e.stopPropagation();

    if (props.callBack) {
      props.callBack();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    key: props.index,
    className: "subMenu-row",
    onClick: function onClick(e) {
      return clickHandler(e);
    }
  }, fillSubRow(props.rowContent));
};

var _default = /*#__PURE__*/_react["default"].memo(GenericSubRow, checkAreEqual);

exports["default"] = _default;
GenericSubRow.propTypes = {
  index: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  callBack: _propTypes["default"].func,
  rowContent: _propTypes["default"].object,
  structure: _propTypes["default"].shape({
    rowFormat: _propTypes["default"].object,
    headers: _propTypes["default"].array,
    dataKeys: _propTypes["default"].array,
    customMemoAreEqual: _propTypes["default"].func
  })
};